export enum UnitsType {
    NUMBERS,
    PERCENTS,
    YEARS
}
